import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { EmbeddedMapElement } from '../../types';

export const EMBEDDED_MAP_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'embedded-map': (node: EmbeddedMapElement) => {
        const title = node.title ? ` title="${escapeHTML(node.title)}"` : '';
        return `<iframe class="wrex-embedded-map" src="${escapeHTML(node.url || '')}"${title}></iframe>`;
    },
};
